import * as React from "react";
import { cn } from "@/shared/lib/utils";

import ArrowIconBlack from "@/assets/icons/arrow/linkBlack.svg?react";
import ArrowIconWhite from "@/assets/icons/arrow/linkWhite.svg?react";

interface IMoreButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string
}

const MoreButton = React.forwardRef<HTMLButtonElement, IMoreButtonProps>(
    ({children, className, ...props }, ref) => {

        const [pressed, setPressed] = React.useState<boolean>(false);
        const [hovered, setHovered] = React.useState<boolean>(false);

        return (
            <button
                ref={ref}
                className={cn(
                    "bg-white-80 h-[38px] pl-[16px] pr-[4px] uppercase font-manrope text-[12px] md:text-[14px] font-bold rounded-full flex justify-between items-center gap-[20px] shadow-glass",
                    className,
                    pressed && "bg-light-blue"
                )}
                {...props}
                onMouseDown={()=>setPressed(true)}
                onMouseUp={()=>setPressed(false)}
                onMouseEnter={()=>setHovered(true)}
                onMouseLeave={()=>{setPressed(false); setHovered(false)}}
                
                onTouchStart={()=>setPressed(true)}
                onTouchEnd={()=>setPressed(false)}
            >

                {children}

                <div className={cn(
                    "h-[30px] w-[30px] rounded-full flex justify-center items-center transition-all ease-linear duration-200",
                    "bg-white-50",
                    hovered && "bg-blue-70",
                    pressed && "bg-white-50 shadow-glass"
                )}>
                    {hovered && !pressed ? (
                        <ArrowIconWhite className="w-[11px] h-[11px] transition-all"/>
                    ) : (
                        <ArrowIconBlack className="w-[11px] h-[11px] transition-all"/>
                    )}
                </div>
            </button>
        );
    }
);

MoreButton.displayName = "MoreButton";

export default MoreButton;